var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M10 1c0-.555-.448-1-1-1-.556 0-1 .448-1 1v7H1c-.555 0-1 .448-1 1 0 .556.448 1 1 1h7v7c0 .555.448 1 1 1 .556 0 1-.448 1-1v-7h7c.555 0 1-.448 1-1 0-.556-.448-1-1-1h-7V1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c652350a30c2a69fd777d8e7c42ebea3.svg";
export { ForwardRef as ReactComponent };